export enum typeContactEnum {
	LEAD_RESIDENTIEL = 1,
	CLIENT_POTENTIEL_RESIDENTIEL = 2,
	GARANT_RESIDENTIEL = 3,
	COLLABORATEUR = 4,
	CLIENT_RESIDENTIEL = 5,
	SUSPECT_RESIDENTIEL = 7
}

export enum typeSocieteEnum {
	SOCIETE_LEAD_RESIDENTIEL = 1,
	SOCIETE_CLIENT_POTENTIEL_RESIDENTIEL = 2,
	SOCIETE_CLIENT_RESIDENTIEL = 3,
	SOCIETE_SUSPECT_RESIDENTIEL = 4,
}